import { connect } from 'react-redux';
import length from 'ramda/es/length';
import assoc from 'ramda/es/assoc';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import lifecycle from 'recompose/lifecycle';

import withPaging from 'app/common/containers/withPaging';
import withSortState from 'app/common/containers/withSortState';

import selectSchools from './selectSchools';
import selectActual from './selectActual';


const defaultSortKey = 'schoolTitle';
const defaultSortDirection = 'down';

export default compose(
  withSortState(defaultSortDirection, defaultSortKey),

  connect(
    (state, props) => {
      const schools = selectSchools(state, props);
      const { balanceNegative, balanceZero, balancePositive } = props.settings;
      return ({
        schools,
        rows: state.settings.reports.rows,
        total: length(schools),
        settings: {
          schoolTitle: true,
          count: true,
          pos: !balanceNegative && !balanceZero,
          neg: !balancePositive && !balanceZero,
          negPercents: !balanceNegative && !balanceZero && !balancePositive,
          total: !balanceNegative && !balancePositive && !balanceZero,
        },
      });
    },
  ),

  withPaging(),
  // setCurrentPage,
  // handlePage,
  // currentPage

  mapProps(props => assoc('schools', selectActual(props), props)),

  lifecycle({
    componentDidUpdate(prevProps) {
      const { rows, setCurrentPage } = this.props;
      if (rows !== prevProps.rows) {
        setCurrentPage(1);
      }
    },
  }),
);
